module.exports = __webpack_public_path__ + "static/media/avatar_icon.f815ece1.svg";